"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsPeriodQuerySchema = void 0;
const zod_1 = require("zod");
function isValidCalendarDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match)
        return false;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    // Local-field round-trip check (never UTC-string parsing, which silently
    // rolls an out-of-range day/month into the next month/year instead of
    // rejecting it — e.g. `new Date("2026-02-30")` would otherwise "succeed"
    // as 02.03.2026). Same technique as `addLocalDays`
    // (packages/shared-format/src/date.ts) uses for calendar-safe arithmetic.
    const asDate = new Date(year, month - 1, day);
    return (asDate.getFullYear() === year && asDate.getMonth() === month - 1 && asDate.getDate() === day);
}
const isoCalendarDateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Neispravan format datuma.")
    .refine(isValidCalendarDate, "Datum ne postoji u kalendaru.");
/**
 * Validates an explicit `from`/`to` analytics period query. Deliberately
 * requires BOTH — Analytics endpoints never silently choose a default date
 * range themselves (docs/NORMAX_PERFORMANCE_ANALYTICS_DASHBOARD_FORENSIC_PRODUCT_BRIEF.md
 * §16's "backend APIs must remain explicit" instruction); any default
 * period (e.g. "current month through yesterday") is a frontend-only
 * concern (Slice B), never resolved here.
 *
 * No maximum-range cap is enforced — no established request-range policy
 * exists anywhere else in this repo to be consistent with (confirmed by
 * source review, docs/NORMAX_PERFORMANCE_ANALYTICS_BACKEND_SLICE_A_IMPLEMENTATION_REPORT.md
 * §4), so none is invented here.
 */
exports.analyticsPeriodQuerySchema = zod_1.z
    .object({
    from: isoCalendarDateSchema,
    to: isoCalendarDateSchema,
})
    .refine((value) => value.from <= value.to, {
    message: "'from' mora biti pre ili jednako 'to'.",
    path: ["to"],
});
//# sourceMappingURL=analytics.js.map